// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins.pkgd.min.js";

import FroalaEditorComponent from "react-froala-wysiwyg";
// import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";

interface FroalaEditorFieldProps {
	value: string; // The content of the editor is a string
	onChange: (content: string) => void; // The onChange function expects a string
}

const FroalaEditor: React.FC<FroalaEditorFieldProps> = ({
	value,
	onChange,
}) => {
	return (
		<>
			<FroalaEditorComponent
				tag="textarea"
				model={value} // Bind Formik's value
				onModelChange={onChange} // Trigger Formik's onChange
				config={{
					placeholderText: "ປ້ອນລາຍລະອຽດ...",
					charCounterCount: true,
					saveInterval: 1000,
					events: {
						"save.before": (html: string) => {
							localStorage.setItem("floaraSavedContent", html);
						},
					},

					toolbarButtons: {
						// Key represents the more button from the toolbar.
						moreText: {
							// List of buttons used in the  group.
							buttons: [
								"bold",
								"italic",
								"underline",
								"strikeThrough",
								"subscript",
								"superscript",
								"fontFamily",
								"fontSize",
								"textColor",
								"backgroundColor",
								"inlineClass",
								"inlineStyle",
								"clearFormatting",
							],

							// Alignment of the group in the toolbar.
							align: "left",

							// By default, 3 buttons are shown in the main toolbar. The rest of them are available when using the more button.
							buttonsVisible: 3,
						},

						moreParagraph: {
							buttons: [
								"alignLeft",
								"alignCenter",
								"formatOLSimple",
								"alignRight",
								"alignJustify",
								"formatOL",
								"formatUL",
								"paragraphFormat",
								"paragraphStyle",
								"lineHeight",
								"outdent",
								"indent",
								"quote",
							],
							align: "left",
							buttonsVisible: 3,
						},

						moreRich: {
							buttons: [
								"insertLink",
								"insertImage",
								"insertVideo",
								"insertTable",
								"emoticons",
								"fontAwesome",
								"specialCharacters",
								"embedly",
								"insertFile",
								"insertHR",
							],
							align: "left",
							buttonsVisible: 3,
						},

						moreMisc: {
							buttons: [
								"undo",
								"redo",
								"fullscreen",
								"print",
								"getPDF",
								"spellChecker",
								"selectAll",
								"html",
								"help",
							],
							align: "right",
							buttonsVisible: 2,
						},
					},
				}}
			/>

			{/* <FroalaEditorView
				model={value} // Bind Formik's value

			/> */}
		</>
	);
};

export default FroalaEditor;
